<mat-card> 
    <mat-card-subtitle>
       Force Logout
    </mat-card-subtitle>
    <mat-card-content>
        <form [formGroup]="logoutForm" novalidate>
            <div *ngIf='!sentOtp'>
                <mat-form-field appearance="outline" >
                    <mat-label>Enter Mobile Number</mat-label>
                    <input matInput placeholder="Enter  Mobile Number" formControlName="mobileNumber">
                    <span matPrefix>+91</span>
                </mat-form-field>
                <div *ngIf="submitted && f.mobileNumber.errors" class="invalid-feedback">
                    <mat-error *ngIf="f.mobileNumber.errors.required">Mobile no is required</mat-error>
                </div>
                <mat-form-field appearance="outline" >
                    <mat-label>Email</mat-label>
                    <input matInput placeholder="Enter  Mobile Number" formControlName="email">
                </mat-form-field>
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                    <mat-error *ngIf="f.email.errors.required">Email is required</mat-error>
                </div>
               </div>
               <div *ngIf='sentOtp'>
                <mat-form-field appearance="outline" >
                    <mat-label>Mobile Otp</mat-label>
                    <input matInput placeholder="Enter  Mobile otp" formControlName="otp">
                </mat-form-field>
                <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                    <mat-error *ngIf="f.otp.errors.required">Mobile otp is required</mat-error>
                </div>
                <mat-form-field appearance="outline" >
                    <mat-label>email Otp</mat-label>
                    <input matInput placeholder="Enter email Otp" formControlName="emailotp">
                </mat-form-field>
                <div *ngIf="submitted && f.emailotp.errors" class="invalid-feedback">
                    <mat-error *ngIf="f.emailotp.errors.required">Email otp is required</mat-error>
                </div>
               </div>
            </form>
            <button mat-flat-button color="primary" (click)="getOtp()" *ngIf='!sentOtp'>
                Send Otp
            </button>
            <button mat-flat-button color="primary" (click)="validateOpt()" *ngIf='sentOtp'>
               Validate
            </button>
            <button mat-flat-button (click)="closepopUp()">
                cancel
             </button>
            </mat-card-content>
</mat-card>